import React, { useReducer, useEffect, Fragment, useState } from "react";
import ReactDOM from "react-dom";
import ReservationModal from "../shared/reservation_modal";
import DayPickerInput from "react-day-picker/DayPickerInput";
import Squares from "react-activity/lib/Squares";
import "react-activity/lib/Squares/Squares.css";
import "react-day-picker/lib/style.css";

function formatDate(date) {
  const y = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
  const m = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(date);
  const d = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
  return `${y}-${m}-${d}`;
}

function prettyFormatDate(date) {
  const m = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(date);
  const d = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
  return `${d}.${m}`;
}

function groupSlots(slots, currency) {
  const grouped = [];
  // [ {groupPrice: 10, coll: [slot1, slot2]}, {groupPrice: 20, coll: [...]} ]
  slots.forEach(slot => {
    const { price, discount } = slot;
    const label = discount
      ? `${price} ${currency} (${discount.value} ${
          discount.unit === "%" ? "%" : currency
        })`
      : `${price}  ${currency}`;
    if (grouped.length === 0)
      return grouped.push({ groupPrice: label, coll: [slot] });
    const lastGroup = grouped[grouped.length - 1];
    label === lastGroup.groupPrice
      ? lastGroup.coll.push(slot)
      : grouped.push({ groupPrice: label, coll: [slot] });
  });
  return grouped;
}

const initState = {
  isLoading: true,
  date: new Date(),
  tables: [],
  chosenSlot: null
};

const reducer = (state, { type, payload }) => {
  switch (type) {
    case "setDate":
      return { ...state, date: payload, isLoading: true };
    case "setSchedules":
      return { ...state, tables: payload, isLoading: false };
    case "setSlot":
      return { ...state, chosenSlot: payload };
    default:
      return state;
  }
};

const Schedules = ({
  iconPath,
  translation,
  months,
  dayNames,
  shortDayNames
}) => {
  const [state, dispatch] = useReducer(reducer, initState);

  const fetchSchedule = () => {
    return fetch(`/schedule.json?date=${formatDate(state.date)}`)
      .then(resp => resp.json())
      .then(payload => dispatch({ type: "setSchedules", payload }));
  };

  useEffect(() => {
    fetchSchedule();
  }, [state.date]);

  return (
    <Fragment>
      <div className="schedule__buttons">
        <div className="dpicker">
          <DayPickerInput
            value={state.date}
            onDayChange={date => dispatch({ type: "setDate", payload: date })}
            formatDate={prettyFormatDate}
            inputProps={{ className: "form__input" }}
            dayPickerProps={{
              months: months,
              weekdaysLong: dayNames,
              weekdaysShort: shortDayNames,
              firstDayOfWeek: 1
            }}
          />
        </div>
      </div>
      {state.isLoading ? (
        <div
          className="quest-calendar schedule__calendar"
          style={{ textAlign: "center" }}
        >
          <Squares size={32} color="#FB6400" />
        </div>
      ) : (
        <Fragment>
          <div className="quest-calendar schedule__calendar">
            <ul className="quest-calendar__list">
              {state.tables.map(({ id, name, slots, show_prices, url }) => {
                const groupedSlots = groupSlots(slots, currency);
                return (
                  <li className="quest-calendar__row" key={id}>
                    <div className="quest-calendar__text-wrapper">
                      <a
                        className="quest-calendar__link"
                        href={url}
                        target="_blank"
                      >
                        {name}
                      </a>
                    </div>
                    <div className="quest-calendar__price-wrapper">
                      {groupedSlots.map(({ groupPrice, coll }, index) => {
                        return (
                          <ul
                            className="quest-calendar__price-list"
                            data-price={show_prices ? groupPrice : ""}
                            key={index}
                          >
                            {coll.map(({ time, active, price, discount }) => {
                              return (
                                <li
                                  className="quest-calendar__price-col"
                                  key={`${id}${state.date}${time}`}
                                >
                                  <button
                                    className="quest-calendar__button"
                                    type="button"
                                    disabled={!active}
                                    onClick={
                                      active
                                        ? () =>
                                            dispatch({
                                              type: "setSlot",
                                              payload: {
                                                id,
                                                name,
                                                time,
                                                price,
                                                discount
                                              }
                                            })
                                        : null
                                    }
                                    data-modal-target="reserve"
                                  >
                                    {time}
                                  </button>
                                </li>
                              );
                            })}
                          </ul>
                        );
                      })}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          {state.chosenSlot && (
            <ReservationModal
              close={() => dispatch({ type: "setSlot", payload: null })}
              iconPath={iconPath}
              itemId={state.chosenSlot.id}
              itemName={state.chosenSlot.name}
              translation={translation}
              date={formatDate(state.date)}
              time={state.chosenSlot.time}
              price={state.chosenSlot.price}
              discount={state.chosenSlot.discount}
              currency={currency}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

const schedulesElement = document.getElementById("schedules");
const iconPath = schedulesElement.dataset.icon;
const translation = schedulesElement.dataset.translation;
const months = schedulesElement.dataset.months;
const dayNames = schedulesElement.dataset.daynames;
const shortDayNames = schedulesElement.dataset.shortdaynames;
const currency = schedulesElement.dataset.currency;
ReactDOM.render(
  <Schedules
    iconPath={iconPath}
    translation={JSON.parse(translation)}
    months={JSON.parse(months)}
    dayNames={JSON.parse(dayNames)}
    shortDayNames={JSON.parse(shortDayNames)}
    currency={currency}
  />,
  schedulesElement
);
